import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";
import {BIPageData} from "./bi-page.data";

@Injectable()
export class BIPageSearchModel extends SearchModel<BIPageData> {

    constructor(injector: Injector) {
        super(injector, BIPageData);
    }

    override getIdentifierField(): string {
        return "id";
    }

    override getResourceName(): string {
        return "bi-page";
    }
}
